<template>
  <div>
    <b-tabs v-model="activeTab" @change="changeTab" size="is-large">
      <b-tab-item :visible="false"></b-tab-item>

      <b-tab-item label="Admin">
        <div>
          <div class="columns m-h-auto has-text-centered">
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">Name Lastname</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">MobilePhone</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">Email</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">organizeName</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">User Status</p>
            </div>
          </div>
          <div v-if="total === 0" class="is-detail-list detail-table">
            <p class="has-text-drak is-size-4 th is-margin-top-s">***</p>
            <p class="has-text-drak is-size-6 th is-padding-x">
              ขณะนี้ไม่มีแอดมิน
            </p>
            <p class="has-text-drak is-size-4 th is-margin-top-s">***</p>
          </div>
          <div
            v-else
            class="columns detail-table is-margin-x-not is-vcentered has-text-centered"
            v-for="(item, index) in adminAll"
            :key="index"
          >
            <div class="column">
              <p class="is-size-7 th">{{ item.name }} {{ item.surname }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.mobilePhone }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.email }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.organizeName }}</p>
            </div>
            <div class="column">
              <b-field class="mg-x-50">
                <b-select
                  placeholder="User Status"
                  v-model="item.userStatus"
                  @input="updateStatusUser(item.id, item.userStatus, 'admin')"
                  icon-pack="fas"
                  icon="check-circle"
                  :class="getColorClass(item.userStatus)"
                  expanded
                >
                  <option :value="0" class="has-text-grey-light">
                    Unverified
                  </option>
                  <option :value="1" class="has-text-warning-yellow">
                    Wait for Approval
                  </option>
                  <option :value="2" class="has-text-primary-green">
                    Verified
                  </option>
                  <option :value="3" class="has-text-danger-status">
                    Suspended
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Staff">
        <div>
          <div class="columns m-h-auto has-text-centered">
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">Name Lastname</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">MobilePhone</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">Email</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">organizeName</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">User Status</p>
            </div>
          </div>
          <div v-if="total === 0" class="is-detail-list detail-table">
            <p class="has-text-drak is-size-4 th is-margin-top-s">***</p>
            <p class="has-text-drak is-size-6 th is-padding-x">
              ขณะนี้ไม่มีแอดมิน
            </p>
            <p class="has-text-drak is-size-4 th is-margin-top-s">***</p>
          </div>
          <div
            v-else
            class="columns detail-table is-margin-x-not is-vcentered has-text-centered"
            v-for="(item, index) in staffAll"
            :key="index"
          >
            <div class="column">
              <p class="is-size-7 th">{{ item.name }} {{ item.surname }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.mobilePhone }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.email }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.organizeName }}</p>
            </div>
            <div class="column">
              <b-field class="mg-x-50">
                <b-select
                  placeholder="User Status"
                  v-model="item.userStatus"
                  @input="updateStatusUser(item.id, item.userStatus, 'staff')"
                  icon-pack="fas"
                  icon="check-circle"
                  :class="getColorClass(item.userStatus)"
                  expanded
                >
                  <option :value="0" class="has-text-grey-light">
                    Unverified
                  </option>
                  <option :value="1" class="has-text-warning-yellow">
                    Wait for Approval
                  </option>
                  <option :value="2" class="has-text-primary-green">
                    Verified
                  </option>
                  <option :value="3" class="has-text-danger-status">
                    Suspended
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Company">
        <div>
          <div class="columns m-h-auto has-text-centered">
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">Name Lastname</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">MobilePhone</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">Email</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">organizeName</p>
            </div>
            <div class="column">
              <p class="is-size-7 has-text-weight-semibold">User Status</p>
            </div>
          </div>
          <div v-if="total === 0" class="is-detail-list detail-table">
            <p class="has-text-drak is-size-4 th is-margin-top-s">***</p>
            <p class="has-text-drak is-size-6 th is-padding-x">
              ขณะนี้ไม่มีแอดมิน
            </p>
            <p class="has-text-drak is-size-4 th is-margin-top-s">***</p>
          </div>
          <div
            v-else
            class="columns detail-table is-margin-x-not is-vcentered has-text-centered"
            v-for="(item, index) in companyAll"
            :key="index"
          >
            <div class="column">
              <p class="is-size-7 th">{{ item.name }} {{ item.surname }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.mobilePhone }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.email }}</p>
            </div>
            <div class="column">
              <p class="is-size-7 th">{{ item.organizeName }}</p>
            </div>
            <div class="column">
              <b-field class="mg-x-50">
                <b-select
                  placeholder="User Status"
                  v-model="item.userStatus"
                  @input="updateStatusUser(item.id, item.userStatus, 'company')"
                  icon-pack="fas"
                  icon="check-circle"
                  :class="getColorClass(item.userStatus)"
                  expanded
                >
                  <option :value="0" class="has-text-grey-light">
                    Unverified
                  </option>
                  <option :value="1" class="has-text-warning-yellow">
                    Wait for Approval
                  </option>
                  <option :value="2" class="has-text-primary-green">
                    Verified
                  </option>
                  <option :value="3" class="has-text-danger-status">
                    Suspended
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
    <b-pagination
      v-model="page"
      :total="total"
      :per-page="limit"
      @change="changePage"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
    </b-pagination>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { HTTP } from "../axios.js";

export default {
  data() {
    return {
      adminConst: [],
      staffConst: [],
      companyConst: [],
      activeTab: 1,
      userStatus: null,
      page: 1,
      limit: 20,
      total: 0,
    };
  },

  mounted() {
    this.fetchAdminAll();
    this.fetchStaffAll();
    this.fetchCompanyAll();
  },
  methods: {
    changeTab() {
      if (this.activeTab === 1) {
        this.page = 1;
        this.total = this.adminConst.length;
      } else if (this.activeTab === 2) {
        this.page = 1;
        this.total = this.staffConst.length;
      } else {
        this.page = 1;
        this.total = this.companyConst.length;
      }
      console.log("activeTab", this.activeTab);
    },
    changePage(page) {
      this.page = page;
    },
    fetchAdminAll() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post("api/user/get/all/user/admin")
        .then((res) => {
          // console.log("api/user/get/all/user/admin", res);
          this.adminConst = res.data.obj.admin ? res.data.obj.admin : [];
          this.total = this.adminConst.length;
        })
        .catch((e) => {
          console.log("api/user/get/all/user/admin/error", e);
        });
    },
    fetchStaffAll() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get("api/get/all/staff")
        .then((res) => {
          // console.log("api/get/all/staff/res", res);
          this.staffConst = res.data.obj ? res.data.obj : [];
          this.total = this.adminConst.length;
        })
        .catch((e) => {
          console.log("api/get/all/staff/error", e);
        });
    },
    fetchCompanyAll() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get("api/get/all/company")
        .then((res) => {
          // console.log("api/get/all/company/res", res);
          this.companyConst = res.data.obj ? res.data.obj : [];
          this.total = this.adminConst.length;
        })
        .catch((e) => {
          console.log("api/get/all/company/error", e);
        });
    },
    getColorClass(status) {
      let classStatus = "";

      switch (status) {
        case 0:
          classStatus = "grey-light";
          break;
        case 1:
          classStatus = "warning-yellow";
          break;
        case 2:
          classStatus = "primary";
          break;
        case 3:
          classStatus = "danger";
          break;
        default:
          break;
      }

      return classStatus;
    },
    getActiveUser(number) {
      let status = false;

      if (number === 1) {
        status = true;
      } else {
        status = false;
      }

      return status;
    },
    updateStatusUser(id, status, rule) {
      const data = {
        userId: id,
        status: status,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post("api/user/active/status", data)
        .then((res) => {
          fetchStaffAll;
          // console.log("api/user/active/status/res", res);
          if (rule === "admin") {
            this.fetchAdminAll();
          } else if (rule === "staff") {
            this.fetchStaffAll();
          } else {
            this.fetchCompanyAll();
          }
        })
        .catch((e) => {
          console.log("api/user/active/status/error", e);
        });
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    companyAll() {
      return this.companyConst.slice(
        (this.page - 1) * this.limit,
        this.page * this.limit
      );
    },
    adminAll() {
      return this.adminConst.slice(
        (this.page - 1) * this.limit,
        this.page * this.limit
      );
    },
    staffAll() {
      return this.staffConst.slice(
        (this.page - 1) * this.limit,
        this.page * this.limit
      );
    },
  },
};
</script>
<style scoped>
.mg-x-50 {
  margin-left: 50px !important;
  margin-right: 50px !important;
}
</style>

